import { useCallback } from "react";
import { ArrowClockwise, Info, WarningCircle } from "@phosphor-icons/react";
import { IconButton } from "@radix-ui/themes";

import { MetricCard } from "../../components/MetricCard";
import { useAdminRead } from "../../hooks/useAdminRead";
import { readAdminData } from "../../services/adminApi";

import type { OverviewData } from "../../types";

const formatDate = (value: number): string => new Intl.DateTimeFormat("tr-TR", {
  dateStyle: "medium",
  timeStyle: "short",
}).format(value);

export function Overview() {
  const load = useCallback(() => readAdminData<OverviewData>({ view: "overview" }), []);
  const { data, error, isLoading, refresh } = useAdminRead({ load });
  return (
    <main className="page">
      <section className="page-heading">
        <div><span className="breadcrumb">GENEL / PLATFORM</span><h1>Genel durum</h1><p>Tayan hesapları, workspace'leri ve operasyonel uyarılar için sınırlı bir anlık görünüm.</p></div>
        <div className="snapshot"><span>{data ? `Oluşturuldu: ${formatDate(data.generatedAt)}` : "Henüz yüklenmedi"}</span><IconButton onClick={() => void refresh()} disabled={isLoading} type="button" aria-label="Yenile" variant="soft"><ArrowClockwise size={18} /></IconButton></div>
      </section>
      {error ? <div className="alert danger"><WarningCircle size={21} /><span><strong>Özet yüklenemedi</strong>{error}</span></div> : null}
      <section className="metric-grid" aria-label="Platform metrikleri">
        {data?.metrics.map((metric) => <MetricCard key={metric.id} metric={metric} />)}
        {isLoading && !data ? Array.from({ length: 6 }, (_, index) => <div className="metric-card skeleton" key={index} />) : null}
      </section>
      <section className="panel">
        <div className="panel-heading"><div><span className="kicker">OPERASYON NOTLARI</span><h2>Dikkat edilmesi gerekenler</h2></div><Info size={21} /></div>
        <div className="notice-list">
          {data?.notices.map((notice) => (
            <article className={`notice status-${notice.status}`} key={notice.id}>
              <span className="status-dot" /><div><strong>{notice.title}</strong><p>{notice.description}</p></div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
